import { Doc } from '@dadohr/shared/domainTypes/document';
import { IEnrollmentForm } from '@dadohr/shared/domainTypes/enrollmentForms';
import { Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { LinkExternal } from '../../../../../components/LinkExternal';
import { useUnsafeTranslation } from '../../../../../i18next';
import { toStandaloneAppEnrollmentFormUrl } from '../../../../../services/experiences/enrollmentForms';

export const EnrollmentFormUrlBanner = ({
  d,
  onViewSettings
}: {
  d: Doc<IEnrollmentForm>;
  onViewSettings?: () => void;
}) => {
  const { t } = useUnsafeTranslation();

  const url = toStandaloneAppEnrollmentFormUrl(d.data);

  return (
    <Alert
      severity="success"
      action={
        onViewSettings && (
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => onViewSettings()}
          >
            {t('View settings')}
          </Button>
        )
      }
    >
      {t('Enrollment Form active')}
      {': '}
      <LinkExternal href={url} color="primary" />
    </Alert>
  );
};
